<script>
    import BetaOptIn from '../BetaOptIn.svelte';
    export let message = 'Default message';
    let emailAddress = '';
    const trackBetaSignup = (email) => {
        track('beta-signup', { email });
    }
  </script>
  
  <style>
    h3 {
          text-align: center;
      }
  </style>
  
  <h3>{message}</h3>

  <BetaOptIn
        emailAddress={emailAddress}
        trackBetaSignup={trackBetaSignup}
    />